import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-continuar-comprando',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './continuar-comprando.component.html',
  styleUrl: './continuar-comprando.component.scss'
})
export class ContinuarComprandoComponent {
  @Input() itemCount: number = 0;

  constructor(public activeModal: NgbActiveModal, private router: Router) {}

  close() {
    this.activeModal.close();
  }
  navigateToProducts() {
    this.activeModal.close();
    this.router.navigate(['/productos']); // Navegar a la página de productos
  }

  navigateToCart() {
    this.activeModal.close();
    this.router.navigate(['/cart']); // Navegar al carrito
  }
}
